export const getAdditionalMemberPrice = ({
  additionalMemberPrice
}: {
  additionalMemberPrice: number;
}) => additionalMemberPrice;
